import React, { useState, useEffect } from 'react';

function LoginScreen({ onLogin, error, isLoading }) {
  const [userId, setUserId] = useState('');

  useEffect(() => {
    if (!isLoading && userId.trim().length === 6) {
      onLogin(userId.trim(), false);
    }
  }, [userId, onLogin, isLoading]);

  const handleIdChange = (e) => {
    setUserId(e.target.value.slice(0, 6));
  };
  
  // [추가] 붙여넣기 아이콘 클릭 시 실행될 함수
  const handlePaste = async () => {
    if (isLoading) return;
    try {
      const text = await navigator.clipboard.readText();
      // 클립보드 내용을 6자리로 잘라서 붙여넣기
      setUserId(text.slice(0, 6));
    } catch (err) {
      console.error('붙여넣기 실패:', err);
    }
  };

  const handleNewUser = () => {
    if (isLoading) return;
    onLogin(null, true);
  };

  return (
    <div className="login-container">
      <h1>EGO Standard 1.0v에 오신 것을 환영합니다</h1>
      <p>ID는 랜덤으로 생성됩니다. 새 코치를 만들어 보세요.</p>
      
      {/* [수정] 입력창과 붙여넣기 버튼을 그룹으로 묶음 */}
      <div className="login-input-group">
        <input
          className="login-input"
          type="text"
          inputMode="text"
          placeholder="기존유저 전용ID"
          value={userId}
          onChange={handleIdChange}
          disabled={isLoading}
          maxLength="6"
        />
        {/* [추가] 붙여넣기 버튼 */}
        <button onClick={handlePaste} className="paste-button" title="붙여넣기" disabled={isLoading}>
            📋
        </button>
      </div>
      
      <button className="new-user-button" onClick={handleNewUser} disabled={isLoading}>
        {isLoading ? <div className="spinner"></div> : '새 코치 만들기'}
      </button>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
}

export default LoginScreen;
